import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

import {cn} from 'spa/css';

import 'spa/Components/Reviews/reviews-filters-sidebar.less';

const ReviewsFiltersSidebarContentWrapper = observer(({children, isAnimatingPanel}) => (
  <aside className={cn(
    'reviews-filters-sidebar v-container',
    isAnimatingPanel ? 'reviews-filters-sidebar--animating' : 'reviews-filters-sidebar--animation-over',
  )}>
    <div className="v-content v-content--expand reviews-filters-sidebar__scroller">
      <div className="reviews-filters-sidebar__container">
        {children}
      </div>
    </div>
  </aside>
));

ReviewsFiltersSidebarContentWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.object,
  ]).isRequired,
  isAnimatingPanel: PropTypes.bool,
};

export default ReviewsFiltersSidebarContentWrapper;



// WEBPACK FOOTER //
// ./spa/Components/Reviews/ReviewsFiltersSidebarContentWrapper.jsx